import React, { useEffect, useState } from 'react';
import Common from "./Common";
import { useDispatch, useSelector } from "react-redux";
import { SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT } from "../../../store/slice/model/Cart";
import CustomerPartNumberOptions from "./CustomerPartNumberOptions";
import CartCommon from "src/component/Global/Cart/Common";
import { isArray } from "underscore";
import { useCartStore } from 'src/hooks/cart';

const PriceTable = (props) => {

    const dispatch = useDispatch();
    const [linesToDisplay, setLinesToDisplay] = useState();
    const [priceTableExpanded, setPriceTableExpanded] = useState(false)
    const { single_product_inventory } = props;
    const { auto_select_from_cart_data = true } = props;
    const { hiddenPriceTableMode = false } = props;
    const { hiddenMode = false } = props;
    const { single_product } = props;
    const ItemNumber = single_product.ItemNumber;
    const { no_bold_price_line_needed } = props;
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const pricing = useSelector((state) => state.entities.model_ProductPricing.master_data)
    const get_single_product_pricing_list = () => {

        if (props.single_product_pricing_list !== undefined) {
            return props.single_product_pricing_list;
        } else {
            return [];
        }
    };
    const single_product_pricing_list = get_single_product_pricing_list();
    const CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER);
    const isDisplayCPN = props.isDisplayCPN === false ? false : true;

    useEffect(() => {
        setLinesToDisplay(props.linesToDisplay === undefined ? 7 : props.linesToDisplay)
    }, [props.linesToDisplay])

    useEffect(() => {
        if (priceTableExpanded) {
            setLinesToDisplay(100)
        }
    }, [priceTableExpanded])

    useEffect(() => {
        async function fetchHere() {
            if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
                updateToCartServer(getPrice())
            }
        }

        /**
         * Ticket #  : 11214
         * Change #  : Below code change to expand only when qty increases
         * Change by : Pankaj
         * Date      : 09 May 2023
         */
        // Check and expand price table
        if (
            CART_BEFORE_TO_SEND_SERVER[ItemNumber] &&
            CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityAddToCart &&
            Number(CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityAddToCart) &&
            props.linesToDisplay === 3) {
            if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 3) {
                // get initial 3 pricing quantity array
                let priceArray = single_product_pricing_list.slice(0, 3).map((x) => x.demandQuantityOut)
                if (priceArray !== undefined && priceArray !== null &&
                    Array.isArray(priceArray) && priceArray.length > 0) {
                    let priceRangeExist = CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityAddToCart <= priceArray[priceArray.length - 1] ? true : false;
                    if (priceRangeExist === false) {
                        setLinesToDisplay(100)
                    }
                }
            }
        }
        fetchHere()
    }, [single_product_pricing_list
        , CART_BEFORE_TO_SEND_SERVER[ItemNumber]
    ]);
    const getLinesToDisplayProp = () => {
        return props.linesToDisplay === undefined ? 7 : props.linesToDisplay;
    };
    const getQuantityAddToCart = () => {
        return new Common().getQuantityAddToCart(single_product, CART_BEFORE_TO_SEND_SERVER)
    };
    const getObjectOfAddToCart = () => {
        return new Common().getObjectOfAddToCart(single_product, CART_BEFORE_TO_SEND_SERVER)
    };
    const get_single_product_pricing_list_length = () => {
        try {
            return single_product_pricing_list !== undefined && isArray(single_product_pricing_list) ? single_product_pricing_list.length : 0;
        } catch (e) {
        }
        return 0;
    };
    const getClass = (single_price, current_index) => {
        let d = new Common().getClass(single_price, current_index, single_product_pricing_list, getQuantityAddToCart(), false)
        if (no_bold_price_line_needed !== undefined &&
            no_bold_price_line_needed === true
        ) {
            return ' ';
        }
        return d ? 'font-bold' : ' ';
    };
    const getPrice = () => {
        let marketPrice;
        try {
            marketPrice = new CartCommon().getCurrentPriceByQuantityAndPriceArray(single_product_pricing_list, getQuantityAddToCart()).marketPrice
        } catch (e) {
        }
        return marketPrice;
    }
    const updateToCartServer = (marketPrice = false) => {
        if (marketPrice !== false) {
            marketPrice = getPrice();
        }
        let before_add_to_cart_product = getObjectOfAddToCart();
        if (marketPrice && before_add_to_cart_product) {
            dispatch(SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
                CART_DATA: {
                    unitPrice: marketPrice,
                    ItemNumber: ItemNumber
                }
            }));
        }
    };
    const getDisplayStatusOfPricingTable = () => {
        return new CartCommon().getDisplayStatusOfPricingTable(single_product_inventory, single_product);
    };
    const getSelectedStatus = () => {
        let priceObj = single_product_pricing_list !== undefined && single_product_pricing_list !== null && Array.isArray(single_product_pricing_list) && single_product_pricing_list.length > 0 ? single_product_pricing_list.find(x => {
            return x.partNumber
        }) : null;

        /**
         * else if condition is used for quickly add part from bom
         * author: Devanshi patel
         */

        if (CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER &&
            CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber].CUSTOMER_PART_NUMBER &&
            priceObj !== undefined && priceObj !== null &&
            priceObj.priceSource !== undefined && priceObj.priceSource !== null &&
            priceObj.priceSource.replace(/\s+/g, '').toUpperCase() === 'CUSTOMERPRICE') {
            return true;
        } else if (
            priceObj !== undefined && priceObj !== null &&
            priceObj.priceSource !== undefined && priceObj.priceSource !== null &&
            priceObj.priceSource.replace(/\s+/g, '').toUpperCase() === 'CUSTOMERPRICE') {
            return true;
        }
        return false;
    };
    const getEndOfLifeFlagForPriceTable = () => {
        return true;
    }
    const [visibility_state, set_visibility_state] = useState(true);
    return (
        <div style={{ display: hiddenMode === true ? 'none' : 'block', }}>
            {isDisplayCPN === true &&
                <CustomerPartNumberOptions
                    auto_select_from_cart_data={auto_select_from_cart_data}
                    single_product_inventory={single_product_inventory}
                    single_product={single_product}
                    updationStartedCallback={() => {
                        set_visibility_state(false)
                    }}
                    updationCompletedCallback={() => {
                        set_visibility_state(true)
                    }}
                    single_product_pricing_list={single_product_pricing_list}
                    displayManualCpn={false}
                />
            }
            {getDisplayStatusOfPricingTable() === true &&
                <>
                    {
                        /**
                         * Owner : Pankaj
                         * Date  : 08/09/2022
                         * Note  : linesToDisplay === 2 will come only in compact view and on that basis will manage the price and display first & last
                         */
                    }
                    {new Common().template_for_pricing(single_product_pricing_list, get_single_product_pricing_list_length(), getClass, linesToDisplay, (linesToDisplay === 2 ? true : false), visibility_state, getSelectedStatus(), getEndOfLifeFlagForPriceTable(), hiddenPriceTableMode)}
                    <a className='text-blue2 d-flex mt-1' href={void (0)} style={{
                        paddingLeft: '0',
                        visibility: visibility_state ? 'visible' : 'hidden'
                    }} onClick={() => {
                        if (linesToDisplay === getLinesToDisplayProp()) {
                            setLinesToDisplay(100)
                            setPriceTableExpanded(true)
                        } else {
                            setLinesToDisplay(getLinesToDisplayProp())
                        }
                    }
                    }>
                        {single_product_pricing_list.length > (getLinesToDisplayProp() - 1) &&
                            <>
                                {linesToDisplay < single_product_pricing_list.length && getEndOfLifeFlagForPriceTable() && hiddenPriceTableMode === false &&
                                    <>
                                        <span className='font-bold font-12'>More Pricing </span>
                                        <i className="fa fa-angle-down font-bold font-18 ms-1"></i>
                                    </>
                                }
                                {linesToDisplay !== getLinesToDisplayProp() &&
                                    <>
                                        <span className='font-bold font-12'>Less Pricing </span>
                                        <i className="fa fa-angle-up font-bold font-16 ms-1"></i>
                                    </>
                                }
                            </>
                        }
                    </a>
                </>
            }
        </div>
    );
};

export default PriceTable;